import classes from "./Header.module.css";

function Header() {
  return <h1 className={classes.header}>Memory</h1>;
}

export default Header;
